<template>
    <div id="r2s5">
        <h2 class="title">
            {{ $t('f_r2S5_title') }}
        </h2>

        <div class="thank-you">
            <img alt="" class="checkmark" src="@images/checkmark.png">

            <p class="thank-you-text">
                {{ $store.state.round2.complaint.source_origin == "gf_insurance" ? $t('f_thank_you_upload_gf_insurance_text') : $t('f_thank_you_text') }}
            </p>

            <div class="own-input">
                <a class="btn btn-orange" href="/">{{ $t('f_close') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data(){
      return {
        state: this.$store.state
      }
    }
  }
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  #r2s5 {
    .title {
      font-size: 30px;
    }

    .thank-you {
      html.tablet &, html.desktop & {
        width: 400px;
        margin: auto;
      }
    }

    .checkmark {
      margin: auto;
      width: 120px;
      display: block;
    }

    .thank-you-text {
      margin: 40px 0;
      text-align: center;
    }

    .btn {
      font-size: 18px;
      line-height: 55px;
    }
  }
</style>
